import React from 'react'
import Page from './Page'
import products from 'carbonlite/data/products'

const Product = ( { match: { params: { slug } } } ) => {
  const product = products.products.find( p => p.slug === slug )
  return <Page page={ product } />
}

export default Product